var _path, _path2, _g, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGroups = function SvgGroups(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 26 26"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.162 8.188s2.222 5.158 2.984 5.947c.38.393.885.597 1.394.604.38.008.763-.096 1.097-.307l.316-.248c.788-.761.81-2.017.048-2.808-.76-.787-5.839-3.188-5.839-3.188",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "groups_svg__a",
    width: 26,
    height: 26,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.195.522h24.9v24.897H.196V.522Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#groups_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m17.19 23.561-.098-.087a3.98 3.98 0 0 1-1.32-2.953 3.98 3.98 0 0 1 3.976-3.977 3.97 3.97 0 0 1 3.11 1.5l.08.103-.06.119a11.6 11.6 0 0 1-5.568 5.241zm-1.269.46a11.5 11.5 0 0 1-6.553 0l-.3-.09.204-.238a4.9 4.9 0 0 0 1.17-3.172A4.907 4.907 0 0 0 5.54 15.62a4.87 4.87 0 0 0-3.393 1.373l-.226.217-.107-.294a11.5 11.5 0 0 1-.694-3.942c0-6.356 5.17-11.525 11.524-11.525 6.356 0 11.527 5.17 11.527 11.525a11.5 11.5 0 0 1-.696 3.942l-.107.294-.226-.217a4.87 4.87 0 0 0-3.394-1.373 4.91 4.91 0 0 0-4.902 4.902c0 1.16.416 2.287 1.173 3.172l.203.238zm-7.725-.547-.097.087-.12-.054a11.6 11.6 0 0 1-5.568-5.242l-.061-.116.083-.104a3.96 3.96 0 0 1 3.107-1.501 3.98 3.98 0 0 1 3.978 3.977 3.98 3.98 0 0 1-1.322 2.953m15.04-3.965c.296-.479.567-.992.802-1.525a12.3 12.3 0 0 0 1.058-5.011C25.096 6.107 19.51.52 12.644.52 5.78.521.194 6.107.194 12.973c0 1.739.356 3.425 1.057 5.01a12.54 12.54 0 0 0 7.072 6.666 12.5 12.5 0 0 0 8.643 0 13 13 0 0 0 1.56-.705 12.55 12.55 0 0 0 4.71-4.435",
    clipRule: "evenodd"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.037 4.067a1.341 1.341 0 1 1-2.683 0 1.341 1.341 0 0 1 2.683 0M7.29 5.741a1.342 1.342 0 1 1-1.878 1.917 1.342 1.342 0 0 1 1.877-1.917Zm-3.523 5.996a1.34 1.34 0 1 1 .06 2.68 1.34 1.34 0 0 1-.06-2.68m14.25-5.996a1.342 1.342 0 1 0 1.878 1.917 1.342 1.342 0 0 0-1.878-1.917m3.522 5.996a1.34 1.34 0 1 0-.06 2.68 1.34 1.34 0 0 0 .06-2.68",
    clipRule: "evenodd"
  })));
};
export { SvgGroups as ReactComponent };
export default __webpack_public_path__ + "groups.c771c2b19b9175edc56e096546cfe77d.svg";